module.exports = __webpack_public_path__ + "static/media/proj20_img20.f3f0bd84.jpg";